<template>
  <FriedModalSubContainer class="sign-evidence">
    <template #header>
      <FriedModalHeader :header="$t('collecting-evidence')" />
    </template>
    <div class="content">
      <p class="sign-explanation">{{ $t('we-are-collecting-evidence-data') }}</p>
      <FriedSpinner class="loader" />
    </div>
  </FriedModalSubContainer>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SignEvidence',
});
</script>
<style lang="scss" scoped>
.content {
  width: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: var(--spacing-100);
  overflow: hidden;

  .loader {
    margin-top: var(--spacing-100);
  }
}
</style>
